export default "__VITE_ASSET__BbqZOm7$__"